/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing a client group.
 */
import { mapGetters } from 'vuex';
import clientGroupService from './../../../../services/client-group';
import priceFieldService from './../../../../services/priceField';
import chartOfAccountsService from './../../../../services/chartOfAccounts';
import clientGroupTransformer from './../../../../transformers/clientGroup';
import Forms from './../../../../utils/forms/forms';
import store from './../../../../store';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
          label: this.$t('form.clientGroups.name.label'),
        },
        description: {
          value: '',
          type: 'textarea',
          label: this.$t('form.clientGroups.description.label'),
        },
        priceFieldId: {
          value: '',
          type: 'select',
        },
        receivables_account_id: {
          value: '',
          type: 'select',
        },
      }),
      loading: false,
      fetchedClientGroup: {},
    };
  },

  computed: {
    ...mapGetters({
      priceFields: 'allPriceFields',
      chartOfAccounts: 'allChartOfAccounts',
    }),
  },

  created() {
    this.show();
  },

  methods: {
    /**
     * Method to update the client group.
     */
    update() {
      this.form.loading = true;
      const clientGroup = clientGroupTransformer.send(this.form.data());
      clientGroupService.update(store.state.route.params.id, clientGroup)
      .then(() => {
        this.$message({
          message: this.$t('static.clientGroups.edit.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'clientGroups.index',
        });
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Fetches the client group object for editing.
     */
    show() {
      this.loading = true;
      Promise.all([
        clientGroupService.show(store.state.route.params.id),
        priceFieldService.all(1),
        chartOfAccountsService.all(),
      ]).then((data) => {
        this.fetchedClientGroup = data[0];
        this.form.assignData(data[0]);
        this.loading = false;
      });
    },
  },

  watch: {
    priceFields(priceFields) {
      const options = priceFields.all.map(type => ({
        id: type.id,
        name: type.name,
      }));
      options.splice(0, 0, { id: '', name: '' });
      this.form.setOptions('priceFieldId', options);
    },
    chartOfAccounts(chartOfAccounts) {
      if (chartOfAccounts && chartOfAccounts.all && chartOfAccounts.all.length > 0) {
        const options = chartOfAccounts.all.map(account => ({
          id: account.id,
          name: `${account.code} - ${account.name}`,
        }));
        options.splice(0, 0, { id: '', name: '' });
        this.form.setOptions('receivables_account_id', options);
        if (this.fetchedClientGroup && this.fetchedClientGroup.receivables_account_id) {
          this.form.setFieldValue('receivables_account_id', this.fetchedClientGroup.receivables_account_id);
        }
      }
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/clientGroups/edit/edit.js